<template>
  <Card class="uk-padding-large uk-margin-medium-bottom" removeHeaderDivider=true>
    <template v-slot:header>
      <div class="" uk-grid>

        <div class="uk-width-1-2 uk-first-column">
          <img src="@/assets/images/logo.svg" height="80" uk-svg />
        </div>
        <div class="uk-width-1-2">
          <h1 class="uk-h1 uk-text-right">Invoice</h1>
        </div>

        <div class="uk-width-1-2 uk-first-column">
          <p class="uk-text-left uk-margin-remove">{{ full_name }}</p>
          <p class="uk-text-left uk-margin-remove">{{ address }}</p>
          <p class="uk-text-left uk-margin-remove">{{ city }}, {{ state }} {{ zip }}</p>
          <p class="uk-text-left uk-margin-remove">{{ country }}</p>
        </div>

        <div class="uk-width-1-2">
          <p class="uk-text-right uk-margin-remove">Number: <span>{{ number }}</span></p>
          <p class="uk-text-right uk-margin-remove">Due Date: <span>{{ due_date | formatDate }}</span></p>
        </div>

      </div>
    </template>
    <template v-slot:body>
      <table class="uk-table uk-table-divider uk-table-large">
        <thead>
          <tr>
            <th class="uk-table-shrink">ID</th>
            <th class="uk-table-expand">Description</th>
            <th class="uk-table-shrink">Quantity</th>
            <th class="uk-table-shrink">Amount</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(line_item, index) in line_items" :key="index" :class="line_item.subtotal == 0 ? '' : 'uk-text-muted'">
            <td class="uk-text-center">{{ parent_item_indexes.includes(index) ? ( parent_item_indexes.indexOf(index) + 1) : ''}}</td>
            <td class="uk-text-nowrap">{{ parent_item_indexes.includes(index) ? line_item.description : remove_date_from_description(line_item.description) }}</td>
            <td class="uk-text-center">{{ parent_item_indexes.includes(index) ? '' : parseInt(line_item.qty)}}</td>
            <td class="uk-text-center">{{ parent_item_indexes.includes(index) ? parent_item_total(line_item.service_id) : line_item.subtotal | formatCurrency }}</td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="3" class="uk-text-right">Subtotal: </td>
            <td class="uk-text-center">{{ total | formatCurrency }}</td>
          </tr>
          <tr class="uk-text-bold">
            <td colspan="3" class="uk-text-right">Total: </td>
            <td class="uk-text-center">{{ total | formatCurrency }}</td>
          </tr>
        </tfoot>
      </table>

    </template>
  </Card>
</template>

<script>
import Card from '@/components/common/card.vue'

export default {
  name: 'BitInvoice',
  components: {
    Card,
  },
  data() {
    return {
    }
  },
  computed: {
    // get the indexes of the 'parent' line items in the invoice as they are styled differently
    parent_item_indexes() {
      let indexes = []
      this.line_items.forEach( (item, i) => {
        if(item.amount == 0)
          indexes.push(i)
      });
      return indexes
    }
  },
  props: ['full_name', 'address', 'city', 'state', 'zip', 'country', 'number', 'due_date', 'total', 'line_items'],
  methods: {
    parent_item_total(service_id) {
      let total = 0;
      this.line_items.forEach( (item) => {
        if(item.service_id == service_id)
          total += parseInt(item.subtotal)
      })
      return total
    },
    remove_date_from_description(description) {
      return description.replace(/\([^()]*\)/g, '')
    }
  }

}
</script>

<style scoped lang="less">
@import "../../assets/less/theme.less";

.uk-table > tfoot {
  font-size: 1rem !important;
}

.uk-table-divider > tfoot > tr:last-child {
  border-top: none !important;

  td {
    padding-top: 0 !important;
  }
}

</style>
